import React from 'react';
import { HeartHandshakeIcon, LeafIcon, InfinityIcon } from 'lucide-react';
import { FadeUp } from '../motion/FadeUp';
const PRINCIPLES = [{
  icon: HeartHandshakeIcon,
  title: 'Human First',
  text: 'Technology should enhance life—not replace it.'
}, {
  icon: LeafIcon,
  title: 'Build for Well-being',
  text: 'Every product should make people happier, healthier, or more connected.'
}, {
  icon: InfinityIcon,
  title: 'Think Long Term',
  text: 'We build for lasting value rather than short-term trends.'
}];
export function Principles() {
  return <section className="w-full bg-white px-6 py-28 md:py-36 lg:px-8" data-id="element-140" data-mp="iuiwngorwuts">
      <div className="mx-auto max-w-6xl" data-id="element-141" data-mp="etp9ipj5nk1y">
        <FadeUp data-id="element-142" data-mp="euqw9r9j9uzi">
          <p className="text-xs font-medium uppercase tracking-[0.24em] text-vermillion" data-id="element-143" data-mp="eva5mjl4bb1x">
            Our Principles
          </p>
        </FadeUp>
        <FadeUp delay={0.08} data-id="element-144" data-mp="297zycxzr2e7q">
          <h2 className="mt-5 max-w-2xl text-4xl font-semibold leading-[1.1] tracking-tightest text-ink md:text-5xl" data-id="element-145" data-mp="298rwogkqeq1p">
            The values behind everything we make.
          </h2>
        </FadeUp>

        <div className="mt-16 grid gap-8 sm:grid-cols-3" data-id="element-146" data-mp="3uyl8n49ejdkj">
          {PRINCIPLES.map(({
          icon: Icon,
          title,
          text
        }, i) => <FadeUp key={title} delay={i * 0.1} className="h-full" data-id="element-147" data-mp="3gzln45h6resl" data-mpi={i}>
              <div className="flex h-full flex-col rounded-2xl border border-black/[0.08] p-8 transition-colors hover:border-black/20" data-id="element-148" data-mp="3l0fb0yumotlh">
                <span className="inline-flex h-11 w-11 items-center justify-center rounded-full border border-vermillion/25 text-vermillion" data-id="element-149" data-mp="clnhnmul7v2i">
                  <Icon className="h-5 w-5" strokeWidth={1.5} data-id="element-150" data-mp="3rscwfxdo6ne" />
                </span>
                <h3 className="mt-6 text-xl font-semibold tracking-tight text-ink" data-id="element-151" data-mp="7slzn5z33fep">
                  {title}
                </h3>
                <p className="mt-3 text-[15px] leading-relaxed text-ink/55" data-id="element-152" data-mp="vhdktde9axhz">{text}</p>
              </div>
            </FadeUp>)}
        </div>
      </div>
    </section>;
}